import {DropCondition} from './optimization.types';

export const DEFAULT_DROP_CONDITIONS: DropCondition[] = [
  {
    minConfidenceLevel: 95,
    minDays: 0,
    minImpressions: 100000,
    minPerformanceLift: 5,
    minResults: 0,
  },
];
